module.exports = __webpack_public_path__ + "assets/img/jewelryBoxBg.c1094848.png";